import { useState } from "react";
import { changePassword } from "../api/authApi";

export default function ChangePasswordModal({ empNo, onClose, onSuccess }) {
  const [form, setForm] = useState({
    currentPassword : "",
    newPassword     : "",
    confirmPassword : "",
  });
  const [error, setError]     = useState("");
  const [loading, setLoading] = useState(false);
  const [showPw, setShowPw]   = useState({
    current: false,
    new    : false,
    confirm: false,
  });

  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));
  const togglePw = (k) => setShowPw(p => ({ ...p, [k]: !p[k] }));

  const handleSubmit = async () => {
    setError("");

    // 프론트 유효성 검사
    if (!form.currentPassword || !form.newPassword || !form.confirmPassword) {
      setError("모든 항목을 입력해주세요."); return;
    }
    if (form.newPassword.length < 8) {
      setError("새 비밀번호는 8자리 이상이어야 합니다."); return;
    }
    if (form.newPassword !== form.confirmPassword) {
      setError("새 비밀번호가 일치하지 않습니다."); return;
    }
    if (form.currentPassword === form.newPassword) {
      setError("현재 비밀번호와 동일한 비밀번호로 변경할 수 없습니다."); return;
    }

    setLoading(true);
    try {
      const res = await changePassword(
        form.currentPassword,
        form.newPassword,
        form.confirmPassword
      );
      if (res.success) {
        onSuccess();
      } else {
        setError(res.message);
      }
    } catch (err) {
      setError("서버 연결에 실패했습니다.");
    } finally {
      setLoading(false);
    }
  };

  const fields = [
    { label: "현재 비밀번호",    key: "currentPassword", pwKey: "current" },
    { label: "새 비밀번호",      key: "newPassword",     pwKey: "new"     },
    { label: "새 비밀번호 확인", key: "confirmPassword", pwKey: "confirm" },
  ];

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        {/* 헤더 */}
        <div style={styles.header}>
          <span style={styles.title}>🔒 비밀번호 변경</span>
          <button style={styles.closeBtn} onClick={onClose}>✕</button>
        </div>

        {/* 바디 */}
        <div style={styles.body}>

          {/* 사번 표시 (읽기 전용) */}
          <div style={styles.field}>
            <label style={styles.label}>사번</label>
            <input
              style={{ ...styles.input, background: "#f0f0f0", color: "#aaa" }}
              value={empNo}
              disabled
            />
          </div>

          {fields.map(f => (
            <div key={f.key} style={styles.field}>
              <label style={styles.label}>
                {f.label} <span style={{ color: "#ff4d4f" }}>*</span>
              </label>
              <div style={styles.inputWrap}>
                <input
                  style={styles.input}
                  type={showPw[f.pwKey] ? "text" : "password"}
                  placeholder={f.label}
                  value={form[f.key]}
                  onChange={e => set(f.key, e.target.value)}
                />
                <span
                  style={styles.eyeIcon}
                  onClick={() => togglePw(f.pwKey)}
                >
                  {showPw[f.pwKey] ? "🙈" : "👁"}
                </span>
              </div>
            </div>
          ))}

          {/* 비밀번호 규칙 안내 */}
          <div style={styles.notice}>
            💡 비밀번호는 8자리 이상 입력해주세요.
          </div>

          {/* 오류 메시지 */}
          {error && (
            <div style={styles.errorBox}>⚠️ {error}</div>
          )}
        </div>

        {/* 푸터 */}
        <div style={styles.footer}>
          <button style={styles.cancelBtn} onClick={onClose}>취소</button>
          <button
            style={{ ...styles.saveBtn, opacity: loading ? 0.7 : 1 }}
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "변경 중..." : "변경"}
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay  : { position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center" },
  modal    : { background: "#fff", borderRadius: 16, width: "100%", maxWidth: 420, margin: "0 16px", boxShadow: "0 20px 60px rgba(0,0,0,0.3)", overflow: "hidden" },
  header   : { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "20px 24px", borderBottom: "1px solid #f0f0f0" },
  title    : { fontSize: 16, fontWeight: 700, color: "#1a1a2e" },
  closeBtn : { background: "none", border: "none", fontSize: 18, color: "#aaa", cursor: "pointer" },
  body     : { padding: "20px 24px", display: "flex", flexDirection: "column", gap: 14 },
  field    : { display: "flex", flexDirection: "column", gap: 6 },
  label    : { fontSize: 13, fontWeight: 600, color: "#444" },
  inputWrap: { position: "relative", display: "flex", alignItems: "center" },
  input    : { width: "100%", border: "1.5px solid #e0e0e0", borderRadius: 8, padding: "10px 40px 10px 12px", fontSize: 14, outline: "none", background: "#fafafa", color: "#1a1a2e", boxSizing: "border-box" },
  eyeIcon  : { position: "absolute", right: 12, fontSize: 16, cursor: "pointer", userSelect: "none" },
  notice   : { background: "#f0f7ff", border: "1px solid #bae0ff", borderRadius: 8, padding: "10px 14px", fontSize: 12, color: "#1677ff" },
  errorBox : { background: "#fff5f5", border: "1px solid #ffcccc", borderRadius: 8, padding: "10px 14px", fontSize: 13, color: "#c0392b" },
  footer   : { display: "flex", gap: 10, justifyContent: "flex-end", padding: "16px 24px", borderTop: "1px solid #f0f0f0" },
  cancelBtn: { background: "#fff", border: "1px solid #e0e0e0", borderRadius: 8, padding: "10px 20px", fontSize: 14, color: "#666", cursor: "pointer" },
  saveBtn  : { background: "linear-gradient(135deg, #1677ff, #4096ff)", border: "none", borderRadius: 8, padding: "10px 20px", fontSize: 14, color: "#fff", fontWeight: 700, cursor: "pointer" },
};